export default {
  computed: {
    activeProducts() {
      return this.products
        .filter(p => p.active)
        .map(ap => {
          const product = Object.assign({}, ap)

          product.versions = product.versions
            .filter(pv => pv.active)
            .map(pv => {
              pv.latest = false
              return pv
            })

          product.versions.unshift({
            id: 'latest',
            name: 'Latest version',
            version: 'latest',
            latest: true,
          })

          return product
        })
    },
  },
  methods: {
    checkProduct(value, id, index) {
      const { products, externalProviders } = this.form

      if (value) {
        this.form.products = products.concat({
          productId: id,
          versionId: null,
          latest: false,
        })
      } else {
        this.form.products = products.filter(p => p.productId !== id)

        const extIndex = externalProviders.findIndex(i => i.productId === id)

        if (extIndex !== -1) {
          this.form.externalProviders.splice(extIndex, 1)
        }
      }

      if (this.form.roles && index !== undefined) {
        value
          ? this.form.roles[index] = []
          : this.form.roles[index] = null
      }
    },
    getFormProductById(id) {
      return this.form.products.find(p => p.productId === id) || {}
    },
    getProductVersionById(versionId, productId) {
      const product = this.activeProducts.find(p => p.id === productId)

      return product.versions.find(v => v.id === versionId)
    },
    selectVersion(versionId, productId) {
      const formProduct = this.getFormProductById(productId)
      const version = this.getProductVersionById(versionId, productId)

      formProduct.versionId = versionId
      formProduct.latest = version.latest
    },
    enterProviderId(productId, providerId) {
      const index = this.form.externalProviders.findIndex(ext => ext.productId === productId)

      if (providerId === '') {
        this.form.externalProviders = this.form.externalProviders.filter(ext => ext.productId !== productId)
        return
      }

      if (index !== -1) {
        this.form.externalProviders[index].externalId = providerId
      } else {
        this.form.externalProviders.push({
          productId,
          externalId: providerId,
        })
      }
    },
  },
}
